import { observer } from "mobx-react";
import { useEffect } from "react";
import UsersDataTable from "./components/UsersDataTable";
import LoadingScreen from "components/Loading/LoadingScreen";
import useDevice from "hooks/useDevice";
import { useLayoutStore, useUserManagementStore, useUserRolePermissionStore } from "contexts/RootStore.context";
import WidthNotSupportedPage from "views/WidthNotSupportedPage";
import NoPermissionsPage from "views/NoPermissionsPage";

const UsersManagement = observer(() => {

  const { isMobileDevice } = useDevice();
  const {
    dataLoading,
    error,
    setUsersLoading,
    LoadData,
    LoadUsers,
    reset,
    gridData,
  } = useUserManagementStore();
  const { canViewConfig } = useUserRolePermissionStore();
  const { setItemCount, setPageError } = useLayoutStore()

  useEffect(() => {
    reset();
    const abortController = new AbortController();

    if (!isMobileDevice) {
      LoadData().then(() => {
        LoadUsers().then(() => {
          setUsersLoading(false)
        }).finally(() => {
          if (abortController.signal.aborted) {
            reset();
          }
        });
      }).finally(() => {
        if (abortController.signal.aborted) {
          reset();
        }
      });
    }
    return () => {
      abortController.abort();
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setItemCount(gridData.length, "Total Users")
  }, [gridData.length, setItemCount])

  useEffect(() => {
    setPageError(error)
  }, [error, setPageError])

  if (!canViewConfig) {
    return <NoPermissionsPage />
  }

  if (isMobileDevice) {
    return <WidthNotSupportedPage />;
  }

  if (dataLoading) {
    return <LoadingScreen />;
  }

  return (
    <UsersDataTable />
  );
})

export default UsersManagement;